// Add your JS customizations here


(function($) {


	var $leBody = $('body'),
		$iconeMenu = $('.c-hamburger'),
		fenetre = $(window);







	/*********************************************************************
	FacetWP - Scroll when pager
	 *********************************************************************/

	$(document).on('facetwp-loaded', function() {
		if (FWP.loaded) {
			$('html, body').animate({
				scrollTop: $('#search-films-form').offset().top
			}, 500);
		}
	});







	/*********************************************************************
	Load More Ajax
	 *********************************************************************/

	function loadMore( event ) {

		event.preventDefault();

		var postType;
		var page = $(this).data('page');
		var laCat = '';

		var prochainePage = parseInt(page, 10);
		prochainePage++;

		if( $leBody.hasClass('home') ){
			postType = 'film';

		}else if( $leBody.hasClass('page-template-tmpl_nouvelles') || $leBody.hasClass('category') ){
			postType = 'post';

			if($leBody.hasClass('category')){
				laCat =  $('#thePostsCont').data('cat');
			}

		}

		$.ajax({
			url: ajaxscroll.ajaxurl,
			type: 'post',
			dataType: 'html',
			data: {
				action: 'ajax_infinitescroll',
				query_vars: ajaxscroll.query_vars,
				page: prochainePage,
				typedepost: postType,
				categorie: laCat
			},
			beforeSend: function() {
				$('#ajaxLoadMore').remove();
				$('.boutonLoadMoreCont').append( '<span id="loaderAjax" class="page-content fa fa-refresh fa-spin"></span>' );
			},
			success: function( html ) {

				if( html !== '' ){
					$('#loaderAjax').remove();
					$('#thePostsCont').append( html );
					$('.boutonLoadMoreCont').append( '<div id="ajaxLoadMore" data-page="'+prochainePage+'" class="boutonLoadMore loadMoreNouvelles">'+formulaireText.loadMore+'</div>' );

					if( $leBody.hasClass('home')  || $leBody.hasClass('archive')){

						$('.NouvelleCont').off();

						$('.NouvelleCont').on('mouseover', function(){
							$(this).children( ".darkerRollover" ).css( "opacity", "0.15" );
						});

						$('.NouvelleCont').on('mouseout', function(){
							$(this).children( ".darkerRollover" ).css( "opacity", "0.4" );
						});
					}

					$('#ajaxLoadMore').off();
					$('#ajaxLoadMore').on('click', loadMore);


				}else{
					$('#loaderAjax').remove();
					$('.boutonLoadMoreCont').append( '<span class="page-content fa fa-ellipsis-h" id="loaderAjax"></span>' );

				}

			}

		});

	}

	$('#ajaxLoadMore').on('click', loadMore);







	/*
		SideBar
	*/

	if( $leBody.hasClass('single-film') || $leBody.hasClass('single-post') || $leBody.hasClass('page-template-tmpl_about')){

		var aside, sectionGrise, stickermax, pos, positionBas, hauteurHeader, stopper, posSectionGrise;

		aside = $('#sticker');
		pos = aside.position();

		hauteurHeader = $('.calculHeader').outerHeight() + 60;
		stopper = hauteurHeader - 150;

		sectionGrise = $('.sectionGrise');

		if( $('.sectionGrise').length == 0 ){
			stickermax = $(document).outerHeight() - $(".site-footer").outerHeight() - aside.outerHeight() - 200;
		}else{
			posSectionGrise = sectionGrise.position();
			stickermax = posSectionGrise.top - aside.outerHeight() - 200;
		}

		function asideCollant(){

			var windowpos = $(window).scrollTop();

			if (windowpos >= stopper && windowpos < stickermax - 250) {

				aside.attr("style", "");
				aside.addClass("stick");

			} else if (windowpos >= (stickermax - 250) ) {
				aside.removeClass(); //un-stick
				aside.css({position: "absolute", top: stickermax + "px"});

			} else {
				aside.removeClass();
			}

		}

		fenetre.on('scroll', asideCollant);
		asideCollant();


		fenetre.resize(function(){

			aside = $('#sticker');
			hauteurHeader = $('.calculHeader').outerHeight() + 120;
			stopper = hauteurHeader - 150;

			if( $('.sectionGrise').length == 0 ){
				stickermax = $(document).outerHeight() - $(".site-footer").outerHeight() - aside.outerHeight() - 200;
			}else{
				posSectionGrise = sectionGrise.position();
				stickermax = posSectionGrise.top - aside.outerHeight() - 200;
			}

			asideCollant();
		});



	}





	/*Slide Show*/

	if( $leBody.hasClass('single-film') ){

		var id, prev_id, next_id, total_img;
		var inAction = false;

		function showLightbox() {

			$('#cacheLightbox').fadeIn(500);

			id = $(this).data('id');
			prev_id = id-1;
			next_id = id+1;
			total_img = $('#GalerieCont img.item').length;


			if ( prev_id === 0 ) {
				prev_id = total_img;
			}
			if ( next_id > total_img ) {
				next_id = 1;
			}

			$('#lightbox div.item-cur img').attr('src', $(this).data('src'));
			$('#lightbox div.item-prev img').attr('src', $('img.item-'+prev_id).data('src'));
			$('#lightbox div.item-next img').attr('src', $('img.item-'+next_id).data('src'));

			$('#lightbox').delay(500).fadeIn(500);


		}


		function closeLightbox() {

			$('#lightbox').fadeOut(500);
			$('#cacheLightbox').fadeOut(500);

			$('#lightbox div.item-cur img').attr('src', '');
			$('#lightbox div.item-prev img').attr('src', '');
			$('#lightbox div.item-next img').attr('src', '');

		}


		function nextImage() {

			if( inAction ){
				return;
			}else{
				inAction = true;
			}



			$('#lightbox div.item-cur').addClass('animated slideOutLeft');

			prev_id = id;
			id = id + 1;
			next_id = id + 1;

			if (id > total_img){
				id = 1;
				next_id = 2;
			}
			if(next_id > total_img){
				next_id = 1;
			}


			$('#lightbox div.item-cur').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){


				var newImgNext= $('img.item-'+next_id).data('src');


				$('#lightbox div.item-cur').removeClass('animated slideOutLeft');

				$('#lightbox div.item-prev').removeClass('item-prev').addClass('tempo');
				$('#lightbox div.item-cur').removeClass('item-cur').addClass('item-prev');
				$('#lightbox div.item-next').removeClass('item-next').addClass('item-cur').hide();
				$('#lightbox div.tempo').removeClass('tempo').addClass('item-next');
				$('#lightbox div.item-next img').attr('src', newImgNext);

				$('div .loaderLightbox').show();


				var $itemCurrent = $('.item img');

				$itemCurrent.on('load', function(){

					$('div .loaderLightbox').hide();
					$('#lightbox div.item-cur').show().addClass('item-cur animated slideInRight');

					$('#lightbox div.item-cur').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
						$('#lightbox div.item-cur').removeClass('animated slideInRight');
					});


					$('.item img').off();
				});

			});

			inAction = false;
		}


		function prevImage() {

			if( inAction ){
				return;
			}else{
				inAction = true;
			}



			$('#lightbox div.item-cur').addClass('animated slideOutRight');

			prev_id = prev_id - 1;
			id = id - 1;
			next_id = next_id - 1;

			if(prev_id === 0){
				prev_id = total_img;
			}
			if(id === 0){
				id = total_img;
			}
			if(next_id === 0){
				next_id = total_img;
			}



			$('#lightbox div.item-cur').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){

				var newImgPrev = $('img.item-'+prev_id).data('src');

				$('#lightbox div.item-cur').removeClass('animated slideOutRight');

				$('#lightbox div.item-next').removeClass('item-next').addClass('tempo');
				$('#lightbox div.item-cur').removeClass('item-cur').addClass('item-next');
				$('#lightbox div.item-prev').removeClass('item-prev').addClass('tempo-cur');
				$('#lightbox div.tempo').removeClass('tempo').addClass('item-prev');
				$('#lightbox div.item-prev img').attr('src', newImgPrev);

				$('div .loaderLightbox').show();

				$('.item img').on('load', function(){

					$('div .loaderLightbox').hide();

					$('#lightbox div.tempo-cur').removeClass('tempo-cur').addClass('item-cur animated slideInLeft');

					$('#lightbox div.item-cur').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
						$('#lightbox div.item-cur').removeClass('animated slideInLeft');
					});
					$('.item img').off();
				});

			});


			inAction = false;
		}


		$(window).keyup(function(e){

			if ( e.keyCode === 27 ) {
				closeLightbox();
			} else if ( e.keyCode === 37 ) {
				prevImage();
			} else if ( e.keyCode === 39 ) {
				nextImage();
			}

		});



		$('img.item').on('click', showLightbox);
		$('span.nextImage').on('mouseup', nextImage);
		$('span.backImage').on('mouseup', prevImage);
		$('span.closeX').on('mouseup', closeLightbox);




		if( $leBody.hasClass('mobile') ){
			$( "#lightbox div.item" ).on( "swipeleft", nextImage );
			$('#lightbox div.item').on('swiperight', prevImage);
		}else{
			$('#lightbox div.item').on('click', nextImage);

		}

	}// fin section single-photos.php pour lightbox






	/*
		formulaire
	*/

	$('#contactF3m').submit(function(){

		var messageRetourSucess = $('#formFeedbackSucess');
		var messageRetourErreur = $('#formFeedbackErreur');

		var leCourriel, leNom, leMessage;

		$('.requiredElement, .messageErreurFormu01').remove();
		var erreur = false;


		leNom = $('#contactF3m #leNom').val().trim();
		leCourriel = $('#contactF3m #leMail').val().trim();
		leMessage = $('#contactF3m #messageMail').val().trim();

		var re = /\D/;
		var leNomValide = re.test(leNom );

		if( leNom === '' || !leNomValide ){
			$('#contactF3m #leNom').before('<span class="requiredElement">' + formulaireText.nomMessage + '</span>');
			erreur = true;
		}

		var regE = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

		if (leCourriel === '' || !regE.test(leCourriel))
		{
			$('#contactF3m #leMail').before('<span class="requiredElement">' + formulaireText.courrielMessage + '</span>');
			erreur = true;
		}

		if( leMessage === '' ){
			$('#contactF3m #messageMail').after('<span class="requiredElement">' + formulaireText.messageMessage + '</span>');
			erreur = true;
		}

		if( erreur ){

			return false;

		} else {

			var $form = $('#contactF3m').serialize();
			var lienAjax = $('#contactF3m').data('action');

			$.ajax({
				type:'POST',
				url: lienAjax,
				data: $form,
				dataType: 'json',
				success: function(data){

					if ( data.success === true ) {

						$('#contactF3m').fadeOut(400, function(){
							messageRetourSucess.html('<span>' + data.msg + '</span>');
							messageRetourSucess.show();
						});


					} else {

						messageRetourErreur.html('<span>' + data.msg + '</span>');
						messageRetourErreur.show();

					}

				}
			});

			return false;

		}


	});


	$('#leNom, #leMail, #messageMail').on('focus', function(){
		$('#formFeedbackErreur').hide();
	});




	/*icone menu*/

	function toggleMenu(){

		if( !$iconeMenu.hasClass('is-active') ){

			$iconeMenu.addClass('is-active');

			$( "#mobilehead" ).animate({ top: '40px'}, 800);


			if( ( fenetre.width() + 15 ) < 499  ){

				$leBody.css({
					"overflow": "hidden",
					"position": "relative"
				});
			}

		}else{

			$iconeMenu.removeClass('is-active');
			$( "#mobilehead" ).animate({ top: '-100%'}, 800);


			$leBody.css({
				"overflow": "auto",
				"position": "static"
			});

		}
	}

	$iconeMenu.on( 'mouseup', function(e){
		e.preventDefault();
		toggleMenu();
	});




	/*
		Ferme le menu quand click sur projet ou infos
	*/
	function siMenuActif(){

		if( $iconeMenu.is(':visible') && $iconeMenu.hasClass('is-active')  ){
			$( "#primary" ).animate({ top: '-100%'}, 800);
			$iconeMenu.removeClass('is-active');
		}
	}




	/*
		Ouvre le menu quand resize si ferme
	*/
	function closeMenu(){

		if( !$iconeMenu.is(':visible') && $iconeMenu.hasClass('is-active')  ){
			$( "#mobilehead" ).css('top', '');
			$iconeMenu.removeClass('is-active');
		}
	}
	$( window ).resize(function() {
		closeMenu();
	});






	/*********************************************************************
	Load More Ajax
	 *********************************************************************/

	function loadMore( event ) {

		event.preventDefault();

		var postType;
		var page = $(this).data('page');
		var laCat = '';

		var prochainePage = parseInt(page, 10);
		prochainePage++;

		if( $leBody.hasClass('home') ){
			postType = 'film';

		}else if( $leBody.hasClass('page-template-tmpl_nouvelles') || $leBody.hasClass('category') ){
			postType = 'post';

			if($leBody.hasClass('category')){
				laCat =  $('#thePostsCont').data('cat');
			}

		}

		$.ajax({
			url: ajaxscroll.ajaxurl,
			type: 'post',
			dataType: 'html',
			data: {
				action: 'ajax_infinitescroll',
				query_vars: ajaxscroll.query_vars,
				page: prochainePage,
				typedepost: postType,
				categorie: laCat
			},
			beforeSend: function() {
				$('#ajaxLoadMore').remove();
				$('.boutonLoadMoreCont').append( '<span id="loaderAjax" class="page-content fa fa-refresh fa-spin"></span>' );
			},
			success: function( html ) {

				if( html !== '' ){
					$('#loaderAjax').remove();
					$('#thePostsCont').append( html );
					$('.boutonLoadMoreCont').append( '<div id="ajaxLoadMore" data-page="'+prochainePage+'" class="boutonLoadMore loadMoreNouvelles">'+formulaireText.loadMore+'</div>' );

					if( $leBody.hasClass('home')  || $leBody.hasClass('archive')){

						$('.NouvelleCont').off();

						$('.NouvelleCont').on('mouseover', function(){
							$(this).children( ".darkerRollover" ).css( "opacity", "0.15" );
						});

						$('.NouvelleCont').on('mouseout', function(){
							$(this).children( ".darkerRollover" ).css( "opacity", "0.4" );
						});
					}

					$('#ajaxLoadMore').off();
					$('#ajaxLoadMore').on('click', loadMore);


				}else{
					$('#loaderAjax').remove();
					$('.boutonLoadMoreCont').append( '<span class="page-content fa fa-ellipsis-h" id="loaderAjax"></span>' );

				}

			}

		});

	}

	$('#ajaxLoadMore').on('click', loadMore);







	/*********************************************************************
	Custom Ajax Search
	 *********************************************************************/

	function searchCatalogue() {
		var searchText, searchGenre, searchAnnee, genreId, anneeId;

		searchText = $('#recherche-texte').val();
		genreId = $('#tax-search-genre').val();
		anneeId = $('#tax-search-annee').val();
		sujetId = $('#tax-search-sujet').val();

		if(searchText === '' && genreId === '' && anneeId === '' && sujetId === ''){
			return;
		}

		$.ajax({
			url: ajaxscroll.ajaxurl,
			type: 'post',
			dataType: 'html',
			data: {
				action: 'ajax_search',
				query_vars: ajaxscroll.query_vars,
				text: searchText,
				genre: genreId,
				annee: anneeId,
				sujet: sujetId
			},
			beforeSend: function() {

				$('#thePostsCont').empty();
				$('.boutonLoadMoreCont').empty();
				$('.boutonLoadMoreCont').append('<span id="loaderAjax" class="page-content fa fa-refresh fa-spin"></span>');

			},
			success: function( html ) {

				$('.boutonLoadMoreCont').empty();

				if( html !== '' ){

					$('#thePostsCont').append( html );

					$('#ajaxLoadMoreSearch').off();

				}else{

					$('#thePostsCont').empty();
					$('.boutonLoadMoreCont').empty();
					$('#thePostsCont').append( '<div id="no-result">'+formulaireText.noresult+'</div>' );

				}

			}

		});


	}
	$('#launch-search').on('click', function(event){

		event.preventDefault();
		searchCatalogue(event);

	});



	/*********************************************************************
	Reset la recherche catalogue
	 *********************************************************************/

	function resetcatalogue( event ) {

		event.preventDefault();

		var postType = 'film';
		var prochainePage = 1;


		$.ajax({
			url: ajaxscroll.ajaxurl,
			type: 'post',
			dataType: 'html',
			data: {
				action: 'ajax_infinitescroll',
				query_vars: ajaxscroll.query_vars,
				page: prochainePage,
				typedepost: postType
			},
			beforeSend: function() {

				$('.boutonLoadMoreCont').empty();

			},
			success: function( html ) {

				if( html !== '' ){

					$('#thePostsCont').empty();
					$('#thePostsCont').append( html );

					$('#tax-search-genre').prop('selectedIndex',0);
					$('#tax-search-annee').prop('selectedIndex',0);
					$('#recherche-texte').val("");

				}

				$('.boutonLoadMoreCont').append( '<div id="ajaxLoadMore" class="boutonLoadMore loadMoreFilms" data-page="1">'+formulaireText.loadMore+'</div>' );

				$('#ajaxLoadMore').off();
				$('#ajaxLoadMore').on('click', loadMore);

			}
		});
	}

	$('#launch-reset').on('click', resetcatalogue);





	/*
		foncionnement petit formulaire de recherche Header
	*/


	$(document).on( 'click', '#searchsubmit', function( event ) {

		event.preventDefault();
		var texteRecherche = $('.inputTextHeader').val();

		if( window.sessionStorage ){

			sessionStorage.setItem('miniSearch',texteRecherche);
			window.location.assign(ajaxscroll.url_film);

		}else{

			alert(formulaireText.nojava);
		}

	});


	/*
		foncionnement petit formulaire de recherche footer
	*/


	$(document).on( 'click', '#searchsubmitFooter', function( event ) {

		event.preventDefault();
		var texteRecherche = $('.inputTextFooter').val();

		if( window.sessionStorage ){

			sessionStorage.setItem('miniSearch',texteRecherche);
			window.location.assign(ajaxscroll.url_film);

		}else{

			alert('Votre nagigateur ne prend pas en charge certaines fonctions. Veuiller effectuer la recherche dans la section catalogue.');
		}

	});



	/*
		Recherche provenant de mini formulaire
	*/

	if( $leBody.hasClass('post-type-archive-film') ){

		var searchReady;

		if( window.sessionStorage ){

			searchReady = sessionStorage.getItem('miniSearch');
			sessionStorage.setItem('miniSearch','');


			if( searchReady !== '' ){

				$('#recherche-texte').val(searchReady);
				searchCatalogue();

			}
		}

	}




	/*
		Rollover fiches nouvelles
	*/

	if( $leBody.hasClass('page-template-tmpl_nouvelles')){

		$('.NouvelleCont').on('mouseover', function(){
			$(this).children( ".darkerRollover" ).css( "opacity", "0.15" );
		});

		$('.NouvelleCont').on('mouseout', function(){
			$(this).children( ".darkerRollover" ).css( "opacity", "0.4" );

		});


	}





	/*
		Ajax f3m sur demande
	*/
	if( $leBody.hasClass('post-type-archive-surdemande') ){

		function f3mDemandeLoad(e){

			e.preventDefault();

			var id;


			id = $(this).attr('id');


			$.ajax({
				url: ajaxscroll.ajaxurl,
				type: 'post',
				dataType: 'json',
				data: {
					action: 'ajax_demande',
					query_vars: ajaxscroll.query_vars,
					ID: id
				},
				beforeSend: function() {
					$('#thePostsCont').fadeOut(400, function(){
						$('#thePostsCont').empty();
						$('#main').append('<div id="loader-demande-wrapper"><span class="page-content fa fa-refresh fa-spin"></span></div');
					});

				},
				success: function( data ) {

					$('#loader-demande-wrapper').remove();

					$('.f3m-demande').removeClass('surDemandeActif');
					$('#'+id).addClass('surDemandeActif');


					$('#thePostsCont').append(data.result);
					$('#thePostsCont').fadeIn();
				}

			});

		}

		$('.f3m-demande').on('click', f3mDemandeLoad);



		var sectionActive = $('#thePostsCont').data('sectionactive');
		$('#'+sectionActive).addClass('surDemandeActif');


	}









	/*********************************************************************
	Data layers for team selection flexible section
	 *********************************************************************/


	function data_layers_team_selection(){

		var film_title = $(this).data('title');
		var film_date = $(this).data('date');

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'film_vhx',
			'film_name': film_title,
			'film_date': film_date
		});

	}
	$('.team-selection-link').on('click', data_layers_team_selection);








	/*********************************************************************
	DATA LAYERS
	 *********************************************************************/

	var index_search_filters = 0;
	window.dataLayer = window.dataLayer || [];

	function get_facets(){
		var used_facets = "";

		const values = Object.entries(FWP.facets);

		values.forEach(function(facet) {

			if(facet[0] !== 'recherche_par_texte' && facet[1].length !== 0 ){

				if(used_facets != ""){
					used_facets += ', ';
				}
				used_facets += facet[1];
			}

		});

		return used_facets;

	}

	function get_keyword(){
		var used_keyword = "";

		const values = Object.entries(FWP.facets);
		values.forEach(function(facet) {

			if( facet[0] == 'recherche_par_texte' && facet[1].length !== 0 ){
				used_keyword = facet[1];
			}
		});

		return used_keyword;

	}



	/*************************************
	Data layers for filters section
	 *************************************/

	document.addEventListener('facetwp-loaded', function() {

		if( index_search_filters >= 1 ){

			var used_facets = get_facets();
			var used_keyword = get_keyword();

			dataLayer.push({
				'event': 'internal_search',
				'search_keyword': used_keyword,
				'filter_name': used_facets,
				'search_sequence': index_search_filters
			});
		}

		index_search_filters++;
		$('.lienFicheFilm, .boutonVimeo').off('click', dataLayersFilms);
		$('.lienFicheFilm, .boutonVimeo').on('click', dataLayersFilms);
	});


	/*****************************************
	Data layers for archive films on click
	 *****************************************/

	function dataLayersFilms(event){
		var bouton = $(this).data('btn');
		var film = $(this).data('film');
		var used_facets = get_facets();
		var used_keyword = get_keyword();

		dataLayer.push({
			'event': 'serp_result',
			'search_keyword': used_keyword,
			'filter_name': used_facets,
			'search_sequence': index_search_filters,
			'click_type': bouton,
			'search_result_click': film,
		});

	}
	$('.lienFicheFilm, .boutonVimeo').on('click', dataLayersFilms);







	/******************************************
	Smooth scroll to anchors
	 ******************************************/

// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function() {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});



})( jQuery );





